const ApiEndpoints = {
  common: {
    contentManagement: "/content-management",
    sitemapGroupUrl: "/sitemap/group",
    contactsUrl: "/contacts",
    sitemapSubGroupUrl: "/sitemap/subgroup",
    sitemapLinkUrl: "/sitemap/link",
    homePageCategoryUrl: "/home-page/category",
    homePageCategoryLinkUrl: "/home-page/category/link",
    lawUrl: "/law",
    countries: "/countries",
    nationalUniversities: "/national-universities",
  },
  settlement: {
    autocomplete: "/settlements/autocomplete",
    baseUrl: "/settlements",
  },
  ac: {
    section: "/admin-console/section",
    page: "/admin-console/page",
    link: "/admin-console/link",
  },
  users: {
    account: "/users/account",
    accountActivation: "/users/account/account-activation",
    autocomplete: "/users/autocomplete",
    search: "/users/search",
    fullDetails: "/users/full-details",
    save: "/users/save",
    myAccount: "/users/my-account",
    userData: {
      recovery: {
        password: "/users/data-recovery/password",
      },
      update: {
        mainData: "/users/data-update/main-data",
        email: "/users/data-update/email",
        password: "/users/data-update/password",
      },
    },
  },
  serviceDefinitions: "/service-definitions",
  feedbacks: "/feedbacks",
  globalMessages: "/global-messages",
  publicGlobalMessages: "/public/global-messages",
  globalMessageTypes: "/global-message-types",
  files: {
    upload: "/file-store/upload",
    content: "/file-store/file-content",
  },
  filesRestricted: {
    upload: "/file-store/upload-restricted",
  },
  email: {
    notifications: "/emails/notifications",
    notificationStatuses: "/emails/notifications/statuses",
    templates: "/emails/templates",
    sender: "/emails",
  },
  roles: {
    getAll: "/roles",
    search: "/roles/search",
    fullDetails: "/roles/full-details",
    addUser: "/roles/add-user",
    removeUser: "/roles/remove-user",
    autocomplete: "/roles/autocomplete",
  },
  groups: {
    getAll: "/groups",
    search: "/groups/search",
    fullDetails: "/groups/full-details",
    save: "/groups/save",
    delete: "/groups/delete",
    addUser: "/groups/add-user",
    removeUser: "/groups/remove-user",
    addRole: "/groups/add-role",
    removeRole: "/groups/remove-role",
    autocomplete: "/groups/autocomplete",
  },
  referenceData: {
    base: "/reference-data",
    search: "/reference-data/search",
    domains: "/reference-data/domains",
    deleteAllByDomain: "/reference-data/all",
  },
  nationalUniversities: {
    base: "/national-universities",
    search: "/national-universities/search",
  },
  documentReceiveMethod: {
    base: "/document-receive-methods",
    search: "/document-receive-methods/search",
  },
  person: {
    extractDateFromCivilId: "/person/birth-date/extraction",
  },
  cache: {
    clearNomenclatures: "/cache/clear",
    clearKeycloak: "/cache/clear/keycloak",
  },
  qualCompare: {
    countryDetails: {
      search: "/qual-compare/country-details/search",
      qfDetails: "/qual-compare/country-qf",
    },
    nomenclature: {
      countryRegion: "/qual-compare/nomenclature/country-region",
      systemType: "/qual-compare/nomenclature/system-type",
    },
  },
};

export { ApiEndpoints };
